import React, { CSSProperties, FunctionComponent, MouseEventHandler } from 'react';
import { FaCirclePlus } from 'react-icons/fa6';

export interface CirclePlusButtonProps {
  title: string;
  size?: number | string;
  onClick: MouseEventHandler<SVGElement>;
  style?: CSSProperties;
}

export const CirclePlusButton: FunctionComponent<CirclePlusButtonProps> = ({ title, size, onClick, style }) => (
  <FaCirclePlus title={title} size={size} onClick={onClick} style={style} />
);
